module.exports = "/static/assets/9e630bf27e8c59bc68c6524826581292.png";